<template>
<NavBar/>
<Header/>
<Services/>
<section class="page-section bg-light" id="portfolio">
<Portfolio></Portfolio>
</section>
<About/>
<Footer/>
<Modal/>  
</template>
<script setup>
import { defineAsyncComponent } from 'vue'
import NavBar from '@/components/NavBar.vue'
import Header from '@/components/Header.vue'
import Services from '@/components/Services.vue'

//import Portfolio from '@/components/Portfolio.vue'
import About from '@/components/About.vue'
import Footer from '@/components/Footer.vue'
import Modal from '@/components/Modal.vue'

const Portfolio = defineAsyncComponent({
  loader: () => import('@/components/Portfolio.vue'),
  delay: 2000 /* delay in ms before showing loading component */,
  timeout: 3000 /* timeout after this many ms */,
});
</script>